import router from "@/router";
import { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import type { Persistor } from "redux-persist";
import { useDispatch, useSelector } from "react-redux";
import { updateUser, type UserSliceState } from "@/store/reducers/userSlice";
import { AppThemeProvider } from "@/theme";
import type { AppDispatch } from "@/store";

interface ICustomPersistGateProps {
  persistor: Persistor;
}

const CustomPersistGate = ({ persistor }: ICustomPersistGateProps) => {
  const [renderChildren, setRenderChildren] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const user = useSelector((state: { user: UserSliceState }) => state.user);
  useEffect(() => {
    const handlePersistorState = () => {
      if (persistor.getState().bootstrapped) setRenderChildren(true);
    };
    const unsubscribe = persistor.subscribe(handlePersistorState);
    handlePersistorState();
    return unsubscribe;
  }, [persistor]);

  useEffect(() => {
    if (renderChildren && !user.updated) void dispatch(updateUser());
  }, [dispatch, renderChildren, user.updated]);

  return renderChildren ? (
    <AppThemeProvider>
      <RouterProvider router={router} />
    </AppThemeProvider>
  ) : null;
};

export default CustomPersistGate;
